/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SimilarProfile } from './';
import {
    SimilarProfileFromJSON,
    SimilarProfileFromJSONTyped,
    SimilarProfileToJSON,
} from './';

/**
 * 
 * @export
 * @interface SimilarProfilesResponse
 */
export interface SimilarProfilesResponse {
    /**
     * 
     * @type {Array<SimilarProfile>}
     * @memberof SimilarProfilesResponse
     */
    similarProfiles: Array<SimilarProfile>;
}

/**
 * Check if a given object implements the SimilarProfilesResponse interface.
 */
export function instanceOfSimilarProfilesResponse(value: object): value is SimilarProfilesResponse {
    if (!('similarProfiles' in value) || value['similarProfiles'] === undefined) return false;
    return true;
}

export function SimilarProfilesResponseFromJSON(json: any): SimilarProfilesResponse {
    return SimilarProfilesResponseFromJSONTyped(json, false);
}

export function SimilarProfilesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimilarProfilesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'similarProfiles': ((json['similarProfiles'] as Array<any>).map(SimilarProfileFromJSON)),
    };
}

export function SimilarProfilesResponseToJSON(value?: SimilarProfilesResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'similarProfiles': ((value['similarProfiles'] as Array<any>).map((v) => SimilarProfileToJSON(v))),
    };
}

